import {createAction} from 'web-app/util/redux/famly-app-helpers';

const domain = 'MANAGE_PRICING_GROUP_RULES';
export const {
    action: search,
    success: searchSuccess,
    failed: searchFailed,
    aborted: searchAborted,
} = createAction(`${domain}/SEARCH`, (institutionId, queryString) => ({institutionId, queryString}));
export const {
    action: save,
    success: saveSuccess,
    failed: saveFailed,
    aborted: saveAborted,
} = createAction(`${domain}/SAVE`, () => ({}));
export const {action: reset} = createAction(`${domain}/RESET`, () => ({}));
